<template>
  <footer :class="{ footer: true, 'm-footer': isMobile }">
    <div class="footer-top" v-if="!isMobile">
      <div class="footer-top-left">
        <img src="@/assets/footer-logo.png" alt="" class="logo-img" />
        <div class="footer-friend">
          <div class="label">公司地址：</div>
          <div class="list">
            <div class="friend" v-for="item in companyList" :key="item.id">
              <a
                class="friend-text"
                :href="item.companyUrl"
                ref="nofollow"
                target="_blank"
                v-if="item.companyUrl"
                >{{ item.companyName }}</a
              >
              <span class="friend-text" v-else>{{ item.companyName }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-top-right">
        <div class="code-title">关注或联系我们</div>
        <div class="code-tip">添加公众号、抖音，关注我们</div>
        <div class="codeimg">
          <div class="code">
            <img
              :src="URL + globalConfig.officialAccountsImgUrl"
              alt=""
              class="in"
            />
          </div>
          <div class="code">
            <img :src="URL + globalConfig.weboImgUrl" alt="" class="in" />
          </div>
        </div>
        <div class="right-info">
          <div>
            联系电话：<span>{{ globalConfig.consultPhone }}</span>
          </div>
          <div>咨询地址：{{ globalConfig.consultAddress }}</div>
        </div>
      </div>
    </div>
    <div class="bottom" v-if="!isMobile">
      {{ globalConfig.copyRightMsg }}
      <a
        href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502030880"
        target="_blank"
      >
        {{ globalConfig.publicSecurityRecord }}
      </a>
      <a href="https://beian.miit.gov.cn/" target="_blank">
        {{ globalConfig.icpMsg }}</a
      >

      <img
        :src="URL + 'icp.png'"
        alt=""
        style="width: 1.2rem; padding-left: 10px"
      />
      <a href="https://beian.mps.gov.cn/#/query/webSearch" target="_blank">
        桂公网安备45010002451331号</a
      >
    </div>
    <div class="m-bottom" v-else>
      <a class="btn" :href="'tel:' + globalConfig.consultPhone">
        <img src="@/assets/icon_phone2.png" alt="" class="icon" />
        <span>{{ globalConfig.consultPhone }}</span>
      </a>
      <button class="btn" @click="navToContact">
        <img src="@/assets/icon_contact.png" alt="" class="icon" />
        <span>免费咨询</span>
      </button>
    </div>
  </footer>
</template>
<script>
import { Store } from "@/store/index.js";
import { mapState } from "pinia";
import { URL } from "@/util/config.js";
export default {
  data() {
    return {
      activeId: 0,
      URL: URL,
      companyList: [],
    };
  },
  computed: {
    ...mapState(Store, ["globalConfig", "isMobile"]),
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      let res = await this.$api.getCompany();
      this.companyList = res.data;
    },
    navToContact() {
      this.$router.push("/contact");
    },
  },
};
</script>
<style lang="scss" scoped>
.footer {
  width: 100%;
  background-color: #fafafa;

  .footer-top {
    width: 1200px;
    margin: 0 auto;
    overflow: hidden;
    position: relative;
    padding: 40px 0 45px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .footer-top-left {
      flex-grow: 1;
      height: 100%;
      padding-bottom: 20px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-right: 10px;

      .logo-img {
        width: 200px;
        vertical-align: top;
      }

      .footer-friend {
        margin-top: 48px;
        width: 100%;
        container-type: inline-size;

        .label {
          font-size: 22px;
          font-weight: 600;
          line-height: 1.2;
          margin-bottom: 16px;
        }
        .list {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 12px;
          width: 100%;

          .friend {
            width: auto;
            max-width: 100%;
            margin-bottom: 0;

            .friend-text {
              display: block;
              color: #677383;
              font-size: 14px;
              line-height: 22px;
              white-space: nowrap;
              position: relative;
              padding-left: 14px;

              &::before {
                content: "";
                position: absolute;
                left: 0;
                top: 8px;
                width: 6px;
                height: 6px;
                border-radius: 50%;
                background-color: $theme;
              }

              &:hover {
                color: $theme;
              }
            }
          }
        }

        @container (min-width: 680px) {
          .list {
            display: grid;
            grid-template-columns: max-content max-content;
            justify-content: space-between;
            align-items: start;
            column-gap: 32px;
            row-gap: 12px;
          }
        }
      }
    }
    .footer-top-right {
      user-select: text;
      flex-shrink: 0;

      img {
        width: 30px;
        vertical-align: middle;
      }
    }
    .code-title {
      font-size: 25px;
      font-weight: bold;
      margin-bottom: 18px;
    }
    .code-tip {
      color: #677383;
      margin-bottom: 20px;
    }
    .codeimg {
      display: flex;
      padding-right: 5px;
    }
    .code {
      width: 135px;
      height: 135px;
      background-color: #fff;
      box-shadow: 0 0 10px rgba(138, 182, 255, 0.3);

      & + .code {
        margin-left: 35px;
      }

      .in {
        width: 100%;
        height: 100%;
      }
    }
    .right-info {
      color: #677383;
      margin-top: 20px;

      span {
        font-size: 27px;
      }
      div + div {
        margin-top: 7px;
      }
    }
  }
  .cj-record {
    text-align: center;
    line-height: 40px;
    font-size: 13px;
    border-top: 1px solid #e4e4e4;
    color: #777777;

    a {
      margin: 0 5px;
      color: #777777;
    }
  }
}
.bottom {
  width: 1300px;
  margin: 0 auto;
  border-top: 1px solid #d2d7de;
  text-align: center;
  padding: 30px 0 70px;
  color: #677383;

  a {
    color: #677383;
  }
}

.m-footer {
  height: 61px;
}
.m-bottom {
  background-color: #fff;
  border-top: 1px solid #cbcbcb;
  padding: 10px 0;
  display: flex;
  justify-content: space-evenly;
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 888;

  .btn {
    width: 40%;
    padding: 10px 0;
    border-radius: 10px;
    background-color: $theme;
    color: #fff;
    font-size: 14px;
    display: block;
    display: flex;
    align-items: center;
    justify-content: center;

    .icon {
      height: 15px;
    }
    span {
      margin-left: 10px;
    }
  }
}

@media (max-width: 1400px) {
  .footer .footer-top {
    width: 1000px;
  }
}
</style>
